<script lang="ts">
	import { appState } from '$lib/app-state.svelte'
	import { cartItems } from '$lib/stores.svelte'
	import NavLink from '$lib/public/layout/NavLink.svelte'
	import UserMenu from '$lib/public/layout/UserMenu.svelte'
	import NavOffcanvas from '$lib/public/layout/NavOffcanvas.svelte'

	let count = $derived($cartItems.reduce((sum, item) => sum + item.quantity, 0))
</script>

<nav
	class="tw:mx-auto tw:w-full tw:px-3 tw:bs-sm:max-w-bs-sm tw:bs-md:max-w-bs-md tw:bs-lg:max-w-bs-lg tw:bs-xl:max-w-bs-xl tw:bs-xxl:max-w-bs-xxl">
	<div class="tw:flex tw:bs-lg:hidden tw:justify-end tw:py-2" role="menu">
		<a
			href="#navOffcanvas"
			class="tw:flex tw:flex-col tw:justify-center tw:items-center tw:gap-1 tw:p-2
         tw:border tw:border-plum tw:rounded-md tw:bg-white tw:hover:bg-lilac tw:hover:text-white tw:*:block tw:*:w-5 tw:*:h-0.5 tw:*:bg-current"
			aria-label="Toggle navigation">
			<span></span>
			<span></span>
			<span></span>
		</a>
	</div>
	<div class="tw:hidden tw:bs-lg:flex" role="menu">
		<NavLink href="/classes" title="Classes" class="tw:ms-42" />
		<NavLink href="/workshops" title="Workshops" />
		<NavLink href="/teachers" title="Teachers" />
		<NavLink href="/teachertraining" title="Teacher Training" />

		{#if appState.user?.role == 'admin'}
			<NavLink href="/admin">Admin<span class="tw:hidden tw:bs-xl:inline">istration</span></NavLink>
		{/if}

		{#if appState.user && appState.user.role != 'student'}
			<NavLink href="/shynet" title="SHYnet" />
		{/if}

		{#if !appState.user}
			<NavLink href="/login" title="Login" class="tw:ms-auto" />
			<NavLink href="/register" title="Create account" />
		{:else}
			<UserMenu />
		{/if}
		<NavLink href="#contactOffcanvas"
			>Contact<span class="tw:hidden tw:bs-lg:inline">&nbsp;us</span></NavLink>
		<NavLink id="cart" href="#cartOffcanvas" class="tw:inline-flex tw:items-center tw:gap-1">
			<svg width="14" height="14" role="img">
				<title>Open shopping cart</title>
				<use href="/images/icons/icons.svg#cart2" />
			</svg>
			{count}
		</NavLink>
	</div>
</nav>

<NavOffcanvas />
